import React from 'react';
import { ThemeProvider } from '@mui/material';

import GlobalStyleProvider from '../styles/GlobalStyleProvider';
import theme, { createRootedTheme } from './Theme';

export const ThemeWrapper: React.FC<
  React.PropsWithChildren<{ children: React.ReactNode; replaceRoot?: boolean }>
> = ({ children, replaceRoot }) => {
  const [targetRoot, setTargetRoot] = React.useState<HTMLDivElement | null>(
    null,
  );
  if (replaceRoot) {
    const targetTheme = createRootedTheme(targetRoot);
    return (
      <ThemeProvider theme={targetTheme}>
        <div ref={setTargetRoot}>
          <GlobalStyleProvider>{children}</GlobalStyleProvider>
        </div>
      </ThemeProvider>
    );
  }
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyleProvider>{children}</GlobalStyleProvider>
    </ThemeProvider>
  );
};
